import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../shared/api.service';
import { Router } from '@angular/router';
import { EventSendeurService } from '../../../shared/event-sendeur.service';
import { NbToastrService, NbDialogRef } from '@nebular/theme';
import { Categorie } from '../../../shared/data/categorie';
import { plainToClass } from 'class-transformer';

@Component({
  selector: 'ngx-edit-category',
  templateUrl: './edit-category.component.html',
  styleUrls: ['./edit-category.component.scss']
})
export class EditCategoryComponent implements OnInit {
  @Input() id: number;

  @Input() cattype: string;
  /* nome;
  desc;
  cate:any = []; */
  cat = new Categorie;
  hideLoader =true;
  hideButon =false;
  // pr;

  selectedItems = [];
  dropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'chemin',
    selectAllText: 'Selectionner tous',
    unSelectAllText: 'Déselectionner tout',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
  };

  categories: any[];

  constructor(protected dialogRef: NbDialogRef<EditCategoryComponent>,private apiService:ApiService, private router:Router,private sendeurService:EventSendeurService, public toastr: NbToastrService) {
  
    if( this.id !== 0 )
    this.getCategories();

  }

  ngOnInit() {

    if(this.cattype !== undefined)
    this.cat.type_content = this.cattype;

    if(this.id !== 0)
    this.getOneCategorie();
   
  }

  cancel(){
    this.dialogRef.close();
    
    
  }

  close(){
    this.dialogRef.close();
    
    
  }

  

  updateCategory(){

    if( this.id !== 0 ) {

      this.hideButon= true;
      this.hideLoader = false;
      this.apiService.updateCategoryProvider(this.cat).subscribe(data =>{
        console.log(data);
        this.toastr.success("mise à jour réussie","success");
        this.dialogRef.close();
        this.sendeurService.sendCategoryEvent(7);

      },(err) =>{
        console.log(err);
        this.toastr.danger("echec de mise à jour réussie, le nom de cette category existe peut être déjà");
        this.hideButon= false;
        this.hideLoader = true;
        if(err.error.code ===401){
          localStorage.clear();
          window.location.reload();
          let link2 = ['/login'];
          this.router.navigate(link2);
        }

        if(err.error.code ===500){
        
            this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
        }
    
      })

    } else {


      this.hideLoader = false;
      this.hideButon = true;
      

      this.apiService.addCategorieProvider(this.cat).subscribe(data =>{
        console.log(data);
        this.toastr.success("Catégorie crée avec success");
        this.dialogRef.close();
        this.sendeurService.sendCategoryEvent(5);
      },(err) =>{
        this.hideLoader = true;
        this.hideButon = false;
        this.toastr.danger("Il se peut qu'une catégorie portant le meme nom existe déjà","erreur");
        console.log(err);
      
        if(err.error.code ===401){
          localStorage.clear();
          window.location.reload();
          let link2 = ['/login'];
          this.router.navigate(link2);
        }

        if(err.error.code ===500){
          this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page","echec");
        }
    
    })



    }
    
  }

  getOneCategorie(){
    this.apiService.getOneCategoryProvider(this.id).subscribe(data =>{
     this.cat = plainToClass(Categorie, data as object);
     this.selectedItems = [this.cat.parent];

     this.getCategories();
     

    },(err) =>{
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
    })
  }

  getCategories(){

    this.apiService.getAllCategoryProvider('').subscribe(data =>{
     
      
      // une categorie ne doit pas avoir comme parent elle-même ou un de ces fils

      const cats: Categorie[] = data as any[];

      if( this.cat.id !== 0) {

        const index = cats.findIndex( item =>item.id === this.cat.id);
        if(index > -1)
        cats.splice(index,1);

      }

      if( this.cat.id !== 0 && this.cat.descendant !== undefined && this.cat.descendant !== null) {

        this.cat.descendant.forEach(element => {

          const index = cats.findIndex( item =>item.id === element);
          if(index > -1)
          cats.splice(index,1);
          
        });

      }

      this.categories = cats;
     
      /* const tmps = data as any[];   
      this.categories = tmps.map(tmp => {
        return {
        
          nom: tmp.nom,   
          id:tmp.id,
          description:tmp.description
        };
      
      }); */

    })
    
  }


  onItemSelect(data: any) {

   this.cat.parent = data;

   if(this.categories !== undefined) {

    const index = this.categories.findIndex( item=>item.id === data.id)
    if( index > -1 ){
      const parent: Categorie = this.categories[index];
      this.cat.type_content = parent.type_content;
    }

   }

   
  }

  
  onItemDeSelect(item: any){

    this.cat.parent = null;

  }

  onSelectAll(items: any) {
    
  }

  onDeSelectAll($event){
    
  }

  onUnSelectAll(){
    
  }

  onDropDownClose($event){
    
  }

  typeCatChanged($event){

    this.cat.type_content = $event;

  }


}
